<span class="switch-sim-nao">
    <!--
        `standalone: true` no ngModel: sem isso ele tentaria se registrar no formulário do componente
        PAI (as diretivas de formulário atravessam a hierarquia de injeção) e o Angular exigiria um
        nome de controle que este campo não tem — quem conversa com o formulário de fora é o
        ControlValueAccessor, não este ngModel interno.
    -->
    <!--
        `readonly`, e não `disabled`: os dois impedem a troca (o `onClick` do PrimeNG testa os dois),
        mas `disabled` esmaece a chave, e em leitura ela precisa continuar mostrando o estado na cor
        cheia — verde ligada, como sempre foi nesta tela. É o mesmo princípio do
        `_form-campos.scss` do módulo, que devolve contraste ao campo de texto em leitura.
    -->
    <p-toggleswitch
        [ngModel]="valor()"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="alternar($event)"
        [readonly]="bloqueado()"
        [inputId]="inputId()"
        [ariaLabel]="ariaLabel() || undefined"
    />
    <span class="switch-sim-nao-estado">{{ valor() ? 'Sim' : 'Não' }}</span>
</span>
